module.exports = __webpack_public_path__ + "hair.svg?58f7850b5e1c26c6872b04b180289042";